import { makeAutoObservable } from 'mobx';
import {
  BlockDDL,
  CurrencyTypeDDL,
  CustomerDDL,
  ElectricBoxDDL,
  ElectricityPriceDDL,
  ElectricMeterDDL,
  FloorDDL,
  IncomeCategoryDDL,
  ShopContractTypeDDL,
  ShopDDL,
  ShopTypeDDL,
  StatusDDL,
  TermsAndConditionDDL,
} from 'src/@types/Choqorak/Settings/ChoqorakCommonDDLTypes';
import { SelectControl, SelectShopControl } from 'src/@types/common';
import { IDDL } from 'src/@types/commonDropdownTypes';

import agent from 'src/api/agent';
export default class ChoqorakCommonDDL {
  BlockOption: SelectControl[] = [];

  ElectricBoxOption: SelectControl[] = [];

  ElectricMeterOption: SelectControl[] = [];

  FloorOption: SelectControl[] = [];

  ShopOption: SelectShopControl[] = [];

  CustomerOption: SelectControl[] = [];

  ShopTypeOption: SelectControl[] = [];

  StatusOption: SelectControl[] = [];

  CurrencyTypeOption: SelectControl[] = [];

  ShopContractTypeOption: SelectControl[] = [];

  ElectricityPriceOption: SelectControl[] = [];

  IncomeCategoryOption: SelectControl[] = [];

  TermsAndConditionOption: SelectControl[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  //#region  loadBlockDDL
  loadBlockeDDL = async () => {
    try {
      const result = await agent.Block.BlockDDL();

      this.setBlockeDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setBlockeDDL = (data: BlockDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.blockName,
        value: op.blockId,
      };
      return optRow;
    });
    this.BlockOption = op;
  };
  //#endregion

  //#region  loadElectricBoxDDL
  loadElectricBoxeDDL = async () => {
    try {
      const result = await agent.ElectricBox.ElectricBoxDDL();

      this.setElectricBoxeDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setElectricBoxeDDL = (data: ElectricBoxDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.electricBoxCode,
        value: op.electricBoxId,
      };
      return optRow;
    });
    this.ElectricBoxOption = op;
  };
  //#endregion

  //#region  loadElectricMeterDDL
  loadElectricMetereDDL = async (electricBoxId: number,ShowAssignedElectricMeter?:boolean) => {
    try {
      const result = await agent.ElectricMeter.ElectricMeterDDL(electricBoxId,ShowAssignedElectricMeter);

      this.setElectricMetereDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setElectricMetereDDL = (data: ElectricMeterDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.electricMeterSerial,
        value: op.electricMeterId,
      };
      return optRow;
    });
    this.ElectricMeterOption = op;
  };
  //#endregion

  //#region  loadFloorDDL
  loadFloorDDL = async () => {
    try {
      const result = await agent.Floor.FloorDDL();

      this.setFloorDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setFloorDDL = (data: FloorDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.floorCode,
        value: op.floorId,
      };
      return optRow;
    });
    this.FloorOption = op;
  };
  //#endregion

  //#region  loadCustomerDDL
  loadCustomerDDL = async () => {
    try {
      const result = await agent.Customer.CustomerDDL();

      this.setCustomerDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setCustomerDDL = (data: CustomerDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: `${op.customerName}(${op.fatherName})`,
        value: op.customerId,
      };
      return optRow;
    });
    this.CustomerOption = op;
  };
  //#endregion

  //#region  loadShopTypeDDL
  loadShopTypeDDL = async () => {
    try {
      const result = await agent.ShopType.ShopTypeDDL();

      this.setShopTypeDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setShopTypeDDL = (data: ShopTypeDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.name,
        value: op.id,
      };
      return optRow;
    });
    this.ShopTypeOption = op;
  };
  //#endregion

  //#region  loadStatusDDL
  loadStatusDDL = async (type?:number) => {
    try {
      const result = await agent.Status.StatusDDL(type);

      this.setStatusDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setStatusDDL = (data: StatusDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.name,
        value: op.id,
      };
      return optRow;
    });
    this.StatusOption = op;
  };
  //#endregion

  //#region  loadShopDDL
  loadShopDDL = async (floorId: number,show?:boolean) => {
    try {
      const result = await agent.Shop.ShopDDL(floorId,show);

      this.setShopDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setShopDDL = (data: ShopDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.shopCode,
        value: op.shopId,
        rentCarrencyId: op.rentCarrencyId,
        rentPerMonth: op.rentPerMonth,
        shopXLocation: op.shopXLocation,
        shopYLocation: op.shopYLocation,
        shopRotationDigree: op.shopRotationDigree,
        shopSize: op.shopSize,
        shopStatus: op.shopStatus,
        rentCarrency: op.rentCarrency,
        electricMeterSerial: op.electricMeterSerial,
      };
      return optRow;
    });
    this.ShopOption = op;
  };
  //#endregion

  //#region  loadCurrencyTypeDDL
  loadCurrencyTypeDDL = async () => {
    try {
      const result = await agent.CurrencyType.CurrencyTypeDDL();

      this.setCurrencyTypeDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setCurrencyTypeDDL = (data: CurrencyTypeDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.name,
        value: op.id,
      };
      return optRow;
    });
    this.CurrencyTypeOption = op;
  };
  //#endregion

  //#region  loadShopContractTypeDDL
  loadShopContractTypeDDL = async () => {
    try {
      const result = await agent.ShopContractType.ShopContractTypeDDL();

      this.setShopContractTypeDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setShopContractTypeDDL = (data: ShopContractTypeDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.name,
        value: op.id,
      };
      return optRow;
    });
    this.ShopContractTypeOption = op;
  };
  //#endregion

  //#region  loadElectricityPriceDDL
  loadElectricityPriceDDL = async () => {
    try {
      const result = await agent.ElectricityPrice.ElectricityPriceDDL();

      this.setElectricityPriceDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setElectricityPriceDDL = (data: ElectricityPriceDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.pricePerKilowat.toString(),
        value: op.electricityPriceId,
      };
      return optRow;
    });
    this.ElectricityPriceOption = op;
  };
  //#endregion

  //#region  loadIncomeCategoryDDL
  loadIncomeCategoryDDL = async () => {
    try {
      const result = await agent.IncomeCategory.IncomeCategoryDDL();

      this.setIncomeCategoryDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setIncomeCategoryDDL = (data: IncomeCategoryDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.name,
        value: op.id,
      };
      return optRow;
    });
    this.IncomeCategoryOption = op;
  };
  //#endregion

  //#region  loadTermsAndConditionDDL
  loadTermsAndConditionDDL = async (type: number) => {
    try {
      const result = await agent.TermsAndCondition.TermsAndConditionDDL(type);

      this.setTermsAndConditionDDL(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  setTermsAndConditionDDL = (data: TermsAndConditionDDL[]) => {
    const op = data.map((op) => {
      const optRow = {
        text: op.termAndConditionDescreption,
        value: op.termAndConditionId,
      };
      return optRow;
    });
    this.TermsAndConditionOption = op;
  };
  //#endregion
}
